// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// Replace with your actual Firebase config when setting up
// const firebaseConfig = {
//   apiKey: "your-api-key-here",
//   authDomain: "your-project-id.firebaseapp.com",
//   projectId: "your-project-id",
//   storageBucket: "your-project-id.appspot.com",
//   messagingSenderId: "your-sender-id",
//   appId: "your-app-id"
// };

const firebaseConfig = {
  apiKey: "AIzaSyDR4QnJJ_WeZr3qwRjG6F4Zh4pbfJSMPRc",
  authDomain: "siddhi-44d99.firebaseapp.com",
  projectId: "siddhi-44d99",
  storageBucket: "siddhi-44d99.firebasestorage.app",
  messagingSenderId: "404965118732",
  appId: "1:404965118732:web:8598deb2651a735f47ef29",
  measurementId: "G-FDXEC00BPD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
